import { track } from "jiffy-analytics";
import "./saved-carts-name-congrats-modal.scss";

const CLASSES = {
  MODAL: ".saved-carts-name-congrats-modal",
  CART_NAME: ".js-saved-carts-name-congrats-modal-cart-name"
};

const triggerSavedCartsCongratsModal = cartName => {
  const $modal = $(CLASSES.MODAL);
  const $cartName = document.querySelector(CLASSES.CART_NAME);

  $cartName.textContent = cartName;
  $modal.modal("show");

  track("saved_carts_first_name_congrats_modal_viewed");
};

export default triggerSavedCartsCongratsModal;
